import type {TestContext} from 'yup';
import {boolean, number, object, string} from 'yup';
import {localize} from '@services/i18n';

export default object().shape({
    sum: number()
        .integer(localize('ValidationMessages_integer'))
        .positive(localize('ValidationMessages_positive'))
        .test({
            name: 'minSum',
            test: (value: number, context: TestContext) =>
                value >= context.parent.minSum
                    ? true
                    : context.createError({
                          message: `${localize(
                              'ValidationMessages_minSum',
                          )} ${context.parent.minSum}`,
                      }),
        })
        .required(localize('ValidationMessages_required')),
    email: string()
        .matches(
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*[a-zA-Z0-9_]@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/,
            localize('ValidationMessages_email'),
        )
        .required(localize('ValidationMessages_required')),
    isRecurrent: boolean(),
});
